module.exports = __webpack_public_path__ + "static/media/consultorio-05.56f7687b.JPG";